<template>
	<div class="container">
		<div class="table-card">
			<div class="table-card-header">
				<div class="table-title">
					My Tasks
				</div>
			</div>

			<!-- Search -->
			<div style="display:flex;justify-content:space-between;align-items:center;margin:10px;">
				<div>
					Total {{ matchCount }} Records
				</div>

				<el-input
					v-model="searchKeyword"
					placeholder="Enter keywords (space-separated supported)"
					clearable
					style="width:300px"
				/>
			</div>

			<!-- Table -->
			<el-table
				ref="tableRef"
				v-loading="tableloading"
				:data="filteredTableData"
				border
				:row-class-name="tableRowClassName"
				style="width: 100%"
				class="table_el"
				empty-text="No data"
			>
				<!-- Actions -->
				<el-table-column width="150" align="center" label="Actions">
					<template slot-scope="scope">
						<el-button type="primary" @click="handlePreview(scope.row)">
							Execute
						</el-button>
					</template>
				</el-table-column>

				<!-- Workflow -->
				<el-table-column label="Workflow" width="160">
					<template slot-scope="scope">
						<span v-html="highlight(getFlowTypeText(scope.row.flow_type))"></span>
					</template>
				</el-table-column>

				<!-- Operation Type -->
				<el-table-column label="Operation Type" width="160">
					<template slot-scope="scope">
						<span v-html="highlight(getOperationText(scope.row.operation))"></span>
					</template>
				</el-table-column>

				<!-- Task Name -->
				<el-table-column prop="step_name" label="Task Name" width="160">
					<template slot-scope="scope">
						<span v-html="highlight(scope.row.step_name)"></span>
					</template>
				</el-table-column>

				<!-- Request ID -->
				<el-table-column prop="request_id" label="Request ID" width="180">
					<template slot-scope="scope">
						<span v-html="highlight(scope.row.request_id)"></span>
					</template>
				</el-table-column>

				<!-- Description -->
				<el-table-column prop="overall_description" label="Description" width="">
					<template slot-scope="scope">
						<span v-html="highlight(scope.row.overall_description)"></span>
					</template>
				</el-table-column>

				<!-- Due Date -->
				<el-table-column prop="end_time" label="Due Date" width="160">
					<template slot-scope="scope">
						<span v-html="highlight(scope.row.end_time)"></span>
					</template>
				</el-table-column>

				<!-- Details -->
				<el-table-column align="center" label="Actions" width="120">
					<template slot-scope="scope">
						<el-link type="primary" @click="handleDetail(scope.row)">
							Details
						</el-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { resourcesApplyList, resourcesUnmannedApplyList } from "../../api/docManage/task/index";
import moment from 'moment';
export default {
	components: {},
	data() {
		return {
			isLoading: true,
			tableloading: false,
			flag: 1,
			keyword: "",
			tableData: [],
			taskKeyword: "",
			searchKeyword: '',
			originTableData: [],
			matchCount: 0
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.getOnwerTaskList();
	},
	computed: {
		// 分词
		keywords() {
			if (!this.searchKeyword) return []
			return this.searchKeyword.toLowerCase().split(/\s+/).filter(Boolean)
		},
		// 过滤数据
		filteredTableData() {
			if (!this.keywords.length) {
				this.matchCount = this.originTableData.length
				return this.originTableData
			}
			const result = this.originTableData.filter(row => {
				return this.matchRow(row)
			})
			this.matchCount = result.length
			this.$nextTick(() => {
				this.scrollToFirst()
			})
			return result
		}
	},
	watch: {
		//
	},
	methods: {
		//表格行警告状态
		tableRowClassName({row, rowIndex}) {
			if(moment(row.end_time).isBefore(moment(), 'day')) {
			    return 'warning-row';
			}else {
				return '';
			}
		},
		//时间戳转换
		initTime(value) {
			if(value) {
				return moment(value * 1000).format('YYYY-MM-DD');
			}
		},
		getOnwerTaskList() {
			let that = this;
			that.tableloading = true;
			resourcesApplyList({ keyword: that.keyword }).then((res) => {
				if(res.code == 200) {
					that.tableloading = false;
					that.originTableData = res.data;
					// console.log(that.originTableData);
				}
				that.isLoading = false;
			});
		},
		// 行匹配
		matchRow(row) {
			const fields = [
				row.jcName,
				row.request_id,
				row.step_name,
				row.overall_description,
				this.getOperationText(row.operation),
				this.getFlowTypeText(row.flow_type),
				row.end_time
			]
			const text = fields.join(' ').toLowerCase()
			return this.keywords.every(k => text.includes(k))
		},
		// operation 映射
		getOperationText(op) {
			const map = {
				1 : 'Create a new document',
				2 : 'Use an existing document',
				3 : 'Discard an existing document',
				4 : 'Restore an outdated document',
				5 : 'Complete training',
				6 : 'Measure training effectiveness',
				7 : 'Request CAPA'
			}
			return map[op] || '/'
		},
		// flow_type 映射
		getFlowTypeText(op) {
			const map = {
				'resources_update' : 'Change Request',
				'train' : 'Training',
				'train_supervise' : 'Training',
				'capa' : 'CAPA'
			}
			return map[op] || '/'
		},
		// 高亮（多关键词）
		highlight(text) {
			if (!text) return ''
			let result = text.toString();
			this.keywords.forEach(k => {
				const reg = new RegExp(`(${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
				result = result.replace(reg, '<span class="highlight">$1</span>')
			})
			return result
		},
		// 滚动到第一条
		scrollToFirst() {
			const table = this.$refs.tableRef
			if (!table) return
			const el = table.$el.querySelector('.el-table__body-wrapper tbody tr')
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
		},
		handleSearch() {},
		//执行
		handlePreview(value) {
			let that = this;
			switch (value.flow_type) {
				case 'resources_update':
					//文档变更
					if (value.step == 1 || value.step == 2) {
						that.$router.push({ path: '/DocControl/changeRequestEdit', query: { oid: value.id, type: 'execute' } });
					}else {
						that.$router.push({ path: '/DocControl/changeRequestDetail', query: { oid: value.id, type: 'execute' } });
					}
				break;
				case 'train':
					that.$router.push({ path: '/TrainControl/train-signature', query: { oid: value.id } });
				break;
				case 'train_supervise':
					that.$router.push({ path: '/task/measure-effect', query: { oid: value.id } });
				break;
				case 'capa':
					switch(value.step) {
						case 1:  //编辑capa
							that.$router.push({ path: '/CapaControl/editCapaRequest', query: { oid: value.id } });
						break;
						case 2:  //查看新请求
							that.$router.push({ path: '/CapaControl/capaDetail', query: { oid: value.id, step: 2 } });
						break;
						case 3:  //确定优先级并分配任务
							that.$router.push({ path: '/CapaControl/capaDetail', query: { oid: value.id, step: 3 } });
						break;
						case 4:  //调查
							that.$router.push({ path: '/CapaControl/descriptionDetail', query: { oid: value.id, step: 4 } });
						break;
						case 5:  //初步审查
							that.$router.push({ path: '/CapaControl/descriptionDetail', query: { oid: value.id, step: 5 } });
						break;
						case 6:  //正式审查
							that.$router.push({ path: '/CapaControl/approveDetail', query: { oid: value.id, step: 6 } });
						break;
						case 7:  //实时 & 验证
							that.$router.push({ path: '/CapaControl/reviewImplementation', query: { oid: value.id, step: 7 } });
						break;
						case 8:  //审查行动实施情况
							that.$router.push({ path: '/CapaControl/reviewImplementation', query: { oid: value.id, step: 8 } });
						break;
						case 9:  //结束审查
							that.$router.push({ path: '/CapaControl/closureReview', query: { oid: value.id, step: 9 } });
						break;
						case 10:  //CAPA有效性验证
							that.$router.push({ path: '/CapaControl/effectiveValidation', query: { oid: value.id, step: 10 } });
						break;
					}
				break;
			}
		},
		//认领
		handlePreview2(value) {
			let that = this;
			switch (value.flow_type) {
			case 'resources_update':
				//文档变更
				that.$router.push({ path: '/DocControl/changeRequestDetail', query: { oid: value.id, type: 'claim' } });
				break;
			}
		},
		//详情
		handleDetail(value) {
			let that = this;
			switch(value.flow_type) {
				case 'resources_update':
					//文档变更
					const routeData = that.$router.resolve({ path: "/DocControl/reviewChangeRequest", query: { id: value.unionid } });
					window.open(routeData.href, "_blank");
				break;
				case 'train':
					//培训 - 完整训练
					const routeData2 = that.$router.resolve({ path: "/TrainControl/record-detail", query: { id: value.unionid } });
					window.open(routeData2.href, "_blank");
				break;
				case 'train_supervise':
					//培训 - 衡量培训效果
					const routeData3 = that.$router.resolve({ path: "/TrainControl/effective-detail", query: { id: value.unionid } });
					window.open(routeData3.href, "_blank");
				break;
				case 'capa':
					//CAPA
					const routeData4 = that.$router.resolve({ path: "/CapaControl/searchDeatil", query: { oid: value.unionid } });
					window.open(routeData4.href, "_blank");
				break;
			}
		},
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
>>> .table-card .highlight {
  background: linear-gradient(120deg, #f56c6c, #ff9a9e);
  color: #fff;
  padding: 0 3px;
  border-radius: 3px;
}
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.table-card {
  margin-top: 16px;
  border: 1px solid #d8dde3;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 10px;
  background: #f5f6f7;
  border-bottom: 1px solid #d8dde3;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.table-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 230px;
}

.search-input ::v-deep .el-input__inner {
  border-radius: 8px;
  border: 1px solid #cfd5db;
  height: 40px;
  line-height: 40px;
}

.collapse-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
}

.document-table {
  width: 100%;
}

.document-table ::v-deep .custom-table-header {
  background: #f4f6f8;
  color: #2f343b;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 2px solid #3c4043;
}

.document-table ::v-deep .custom-table-cell {
  color: #2f343b;
  font-size: 14px;
}

.document-table ::v-deep .el-table__cell {
  padding: 12px 8px;
}

.document-table ::v-deep .cell {
  word-break: break-word;
  line-height: 1.5;
}
</style>

